import React from 'react';

interface FloatingTabsProps {
    activeTab: 'chat' | 'data';
    onTabChange: (tab: 'chat' | 'data') => void;
}

export const FloatingTabs: React.FC<FloatingTabsProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[49] group">
            <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-gray-200/50 p-1.5 transition-all duration-300 ease-out">
                <div className="flex">
                    <button
                        onClick={() => onTabChange('chat')}
                        className={`px-3 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ease-out group-hover:px-8 cursor-pointer ${
                            activeTab === 'chat'
                                ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/25 scale-105'
                                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                        }`}
                    >
                        <span className="inline-block transition-all duration-300 ease-out">
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
                            </svg>
                        </span>
                        <span className="inline-block w-0 overflow-hidden group-hover:w-auto group-hover:ml-2 transition-all duration-300 ease-out">
                            Chat
                        </span>
                    </button>
                    <button
                        onClick={() => onTabChange('data')}
                        className={`px-3 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ease-out group-hover:px-8 cursor-pointer ${
                            activeTab === 'data'
                                ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/25 scale-105'
                                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                        }`}
                    >
                        <span className="inline-block transition-all duration-300 ease-out">
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                            </svg>
                        </span>
                        <span className="inline-block w-0 overflow-hidden group-hover:w-auto group-hover:ml-2 transition-all duration-300 ease-out">
                            Data
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};